import React from 'react';
import T from 'prop-types';

import { MODAL_EMAIL_CONFIRMATION, MODAL_LOGIN } from '../../../../constants/app';

import ConfirmationModal from '../../../confirmationModal';

const EmailConfirmationModal = ({
  activated,
  confirmEmail,
  error,
  errorMessage,
  isLoading,
  isVisible,
  updateQueryString,
}) => {
  const handleOnOk = () => {
    updateQueryString({
      modal: MODAL_LOGIN,
      secret: undefined,
    });
  };

  return (
    <ConfirmationModal
      activated={activated}
      error={error}
      errorMessage={errorMessage}
      isLoading={isLoading}
      isVisible={isVisible}
      loadingMessage="Activating your account."
      name={MODAL_EMAIL_CONFIRMATION}
      okText="Log In"
      onLoad={confirmEmail}
      onOk={handleOnOk}
      successMessage="You can now log in to your account."
      title="Account Activation"
    >
      {alert}
    </ConfirmationModal>
  );
};

EmailConfirmationModal.propTypes = {
  confirmEmail: T.func.isRequired,
  updateQueryString: T.func.isRequired,

  activated: T.bool.isRequired,
  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isVisible: T.bool.isRequired,
  isLoading: T.bool.isRequired,
};

export default EmailConfirmationModal;
